<template>
  <!-- A user without projects: what a project is and how to create one (task 52) -->
  <v-alert type="info" variant="tonal" class="mb-3">
    У вас пока нет проектов. Проект — это запрос (набор запросов), по которому Следограф ищет упоминания в источниках;
    графики, сообщения и отчёты строятся по проектам.
    <router-link to="/help/start#first-project">Как создать первый проект</router-link>
    <template #append>
      <v-btn color="primary" variant="elevated" prepend-icon="mdi-plus" :to="{ name: 'createProject' }">Создать проект</v-btn>
    </template>
  </v-alert>
</template>

<script>
export default {
  name: 'NoProjectsAlert'
}
</script>
